<template>
  <div class="hzc-price-index">
    <div class="back">
      当前位置：<span style="cursor: pointer" @click="back('/coke')">焦炭</span> >
      <span style="cursor: pointer" @click="back('/coke/twoPage/cost')">成本利润</span> > 正文
    </div>
    <DetailTitle :title="title"></DetailTitle>
    <ve-table border-y :columns="columns" :table-data="tableData"
              style="width:100%;margin-top: 10px;"
              :scroll-width="1200"
              :max-height="750"
              :fixed-header="true"
              :cell-span-option="cellSpanOption" rowKeyFieldName="rowKey"/>
    <!--    <div class="textarea">-->
    <!--      <p>情况说明</p>-->
    <!--      <el-input-->
    <!--          type="textarea"-->
    <!--          :rows="2"-->
    <!--          placeholder="请输入内容"-->
    <!--          v-model="textarea">-->
    <!--      </el-input>-->
    <!--    </div>-->
  </div>
</template>

<script>
import DetailTitle from "@/components/common/detatilTitle";
import {determination} from "@/api/coke";

export default {
  name: "priceIndex",
  components: {
    DetailTitle,
  },
  data() {
    return {
      cellSpanOption: {
        bodyCellSpan: this.bodyCellSpan,
      },
      id: "",
      tabHead: [],
      name: "",
      remark: "",
      title: "",
      columns: [
        {
          title: "区域",
          fixed: "left",
          children: [
            {
              field: "xiangmu",
              key: "gg",
              fixed: "left",
              title: "项目",
              width: 100,
            },
            {
              title: "地区(省)",
              fixed: "left",
              children: [
                {
                  field: "diqu",
                  key: "diqu",
                  title: "典型企业",
                  fixed: "left",
                  width: 100,
                }
              ]
            },
            {
              field: "zhibiao",
              key: "zhibiao",
              title: "项目指标",
              fixed: "left",
              width: 100,
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "河北省",
              width: 100,
              children: [
                {
                  field: "hebeixuyang",
                  key: "hebeixuyang",
                  title: "河北旭阳",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "河北省",
              width: 100,
              children: [
                {
                  field: "zhongmeixuyang",
                  key: "zhongmeixuyang",
                  title: "中煤旭阳",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "南方组",
          children: [
            {
              title: "山东省",
              width: 100,
              children: [
                {
                  field: "huichengxuyang",
                  key: "huichengxuyang",
                  title: "郓城旭阳",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "内蒙古自治区",
              width: 100,
              children: [
                {
                  field: "xuyangzhongran",
                  key: "xuyangzhongran",
                  title: "旭阳中燃",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "南方组",
          children: [
            {
              title: "江西省",
              width: 100,
              children: [
                {
                  field: "hongyunengyuan",
                  key: "hongyunengyuan",
                  title: "宏宇能源",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "内蒙古自治区",
              width: 100,
              children: [
                {
                  field: "zhongshengkeji",
                  key: "zhongshengkeji",
                  title: "中盛科技",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "山西省",
              width: 100,
              children: [
                {
                  field: "jiaochenghuaxin",
                  key: "jiaochenghuaxin",
                  title: "交城华鑫",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "内蒙古自治区",
              width: 100,
              children: [
                {
                  field: "wuhaiguangna",
                  key: "wuhaiguangna",
                  title: "乌海广纳",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "山西省",
              width: 100,
              children: [
                {
                  field: "xiaoyijinda",
                  key: "xiaoyijinda",
                  title: "孝义金达",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "河北省",
              width: 100,
              children: [
                {
                  field: "hongao",
                  key: "hongao",
                  title: "宏奥",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "南方组",
          children: [
            {
              title: "河北省",
              width: 100,
              children: [
                {
                  field: "huafeng",
                  key: "huafeng",
                  title: "华丰",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "内蒙古自治区",
              width: 100,
              children: [
                {
                  field: "meifang",
                  key: "meifang",
                  title: "美方",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "吉林",
              width: 100,
              children: [
                {
                  field: "dongsheng",
                  key: "dongsheng",
                  title: "东圣",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "内蒙",
              width: 100,
              children: [
                {
                  field: "defeng",
                  key: "defeng",
                  title: "得丰",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "黑龙江省",
              width: 100,
              children: [
                {
                  field: "baotailong",
                  key: "baotailong",
                  title: "宝泰隆",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "宁夏回族自治区",
              width: 100,
              children: [
                {
                  field: "baofeng",
                  key: "baofeng",
                  title: "宝丰",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
        {
          title: "北方组",
          children: [
            {
              title: "青海省",
              width: 100,
              children: [
                {
                  field: "qinghua",
                  key: "qinghua",
                  title: "庆华",
                  width: 100,
                  edit: true,
                },
              ],
            },
          ],
        },
      ],
      tableData: [],
      textarea: ''
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      determination(this.id).then((res) => {
        this.tableData.push(JSON.parse(res.data.detaileJson).table[15])
        this.tableData.push(JSON.parse(res.data.detaileJson).table[26])
        this.tableData.push(JSON.parse(res.data.detaileJson).table[27])
        this.tableData[0]['xiangmu'] = '价格'
        this.tableData[1]['xiangmu'] = '价格'
        this.tableData[2]['xiangmu'] = '价格'
        this.textarea = JSON.parse(res.data.detaileJson).textarea;
        this.title = res.data.titleTime + "焦炭地区煤焦价格、价差测定表";
      });
    },
    // body cell span
    /**
     * 拆分单元格
     * @param row
     * @param column
     * @param rowIndex
     * @returns {{colspan: number, rowspan: number}}
     */
    bodyCellSpan({row, column, rowIndex}) {
      if (column.field === 'xiangmu') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else if (rowIndex === 1) {
          return {
            rowspan: 1,
            colspan: 0,
          };
        } else if (rowIndex === 2) {
          return {
            rowspan: 1,
            colspan: 0,
          };
        }
      }
    },
    /**
     * 后退
     * @param url
     */
    back(url) {
      this.$router.push({path: url});
    },
  },
};
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .textarea {
    font-size: 0;

    p {
      display: inline-block;
      width: 300px;
      font-size: 14px;
      border: 1px solid #ccc;
      height: 54px;
      line-height: 54px;
      vertical-align: top;
      margin: 0;
      text-align: center;
    }

    .el-textarea {
      width: 898px;
      vertical-align: top;

      .el-textarea__inner {
        resize: none !important;
      }
    }
  }
}
</style>
